import { b } from './chunk-IMSWER4T.js';

var r=class extends b{URL="api-access-tokens";async refresh(o){return (await this._client.get(`/api-access-tokens/${o}/refresh`)).data}};

export { r as a };
//# sourceMappingURL=chunk-AFPKM2WC.js.map
//# sourceMappingURL=chunk-AFPKM2WC.js.map